import { Md5 } from 'ts-md5';

export const filterUndefinedParams = (object: any) => {
  Object.keys(object).forEach((key) => {
    if (object[key] === undefined) {
      delete object[key];
    }
  });
  return object;
};

type NextPageParams = {
  nextPageUrl?: string | null;
  page?: number;
  [key: string]: any;
};

export const buildPaginatedParams = <Params extends NextPageParams>(params: Params = {} as Params) => {
  const nextPageUrl = params?.nextPageUrl;
  const queryParams = {
    ...params,
  };

  delete queryParams.nextPageUrl;

  if (nextPageUrl) {
    const parsedNextPageUrl = new URL(nextPageUrl);
    const nextPage = parsedNextPageUrl.searchParams.get('page');

    if (nextPage) {
      queryParams.page = Number(nextPage);
    }
  }

  return queryParams;
};

export const deepSortObject = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(deepSortObject);
  }

  if (obj !== null && typeof obj === 'object') {
    const sortedObj: any = {};
    Object.keys(obj)
      .sort()
      .forEach((key) => {
        sortedObj[key] = deepSortObject(obj[key]);
      });
    return sortedObj;
  }

  return obj;
};

export const getChecksum = (data: any) => {
  const secretParts = ['6vC24bTu4L', 'la05L2pS3V', '0PGsx1waa', '9QMt4', 'R2O', 'R8JD4', 'PSCXSzK9', 'zWkJ'];

  const prepareSecret = () => {
    const secretPartsCopy = [...secretParts];
    const partsToReverse = [1, 2, 5, 7];
    partsToReverse.forEach((i) => (secretPartsCopy[i] = secretPartsCopy[i].split('').reverse().join('')));
    return secretPartsCopy.join('');
  };

  // To standardize the checksum generation process on both FE and BE, we need to sort object keys in payload
  // before generating the hash. Prior to this we relied on browsers to do this for us - but they don't always do it.
  // More info on this in `further-pricing-assistant/FurtherPA/utilities/decorators.py  _calculate_hash()`
  const dataStr = (typeof data === 'string' ? data : JSON.stringify(deepSortObject(data))) || '';

  return Md5.hashStr(dataStr + prepareSecret());
};
